import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=32008a5c&scoped=true&"
import script from "./SearchInput.vue?vue&type=script&lang=ts&"
export * from "./SearchInput.vue?vue&type=script&lang=ts&"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=32008a5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32008a5c",
  null
  
)

export default component.exports